/*
 * This module implement the add to bag for standalone buttons
 * (different than the pdp main product, quickbuy, clp _wsModules).
 *
 * The button will be automatically enabled when all information are available.
 * In case the product is not available the button will be hidden.
 *
 * Markup example:
 *  <button class="standalone-shoppable" data-catEntryId="158376" data-tea-pagename="Pdp" data-tea-pagearea="Accessories" data-tea-element="Cta" disabled aria-disabled="true">ADD TO BAG</button>
 *  <a href="javascript:;" class="standalone-shoppable" data-catEntryId="{{catentryId}}" data-tea-pagename="Pdp" data-tea-pagearea="Accessories" data-tea-element="Cta" disabled aria-disabled="true">ADD TO BAG</a>
*/
(function() {

  var config = {};
  var host = window.location.host;

  /* Module init */
  var init = function(){

    /* Load configuration params from page */
    var urlProductJson = location.pathname;
    var catalogId = $('#catalogId').val();
    var langId = $('#langId').val();
    var storeId = $('#storeId').val();
    var orderId = $('#OrderId').val() || '';

    //build catEntries list with data attributes from the .standalone-shoppabel "Add to bag" buttons
    var catEntriesIdArr = [];
    $('.standalone-shoppable').each(function() {
      catEntriesIdArr.push($(this).attr('data-catEntryId'));
    });
    var catEntriesIdList = '';
    for (var i = 0; i < catEntriesIdArr.length; i++) {
      catEntriesIdList = catEntriesIdList + (i !== 0 ? ',' : '');
      catEntriesIdList = catEntriesIdList + catEntriesIdArr[i] + '_FALSE';
    }

    config = {
      "urlProductJson": urlProductJson,
      "catalogId": catalogId,
      "langId": langId,
      "storeId": storeId,
      "orderId": orderId,
      "catEntriesIdList": catEntriesIdList
    };

    if (catEntriesIdArr.length > 0) {
      checkAvailability();
    }
  };

  /*
   * Check products availability making a request to ProductStylesJSONView
   * for each .standalone-shoppable button.
   */
  var checkAvailability = function() {
    var urlToCall = config.urlProductJson + "/ProductStylesJSONView?storeId=" + config.storeId + "&catalogId=" + config.catalogId + "&langId=" + config.langId + "&catEntries=" + config.catEntriesIdList;
    $.ajax({
      method: "GET",
      dataType: "json",
      url: urlToCall,
      success: function(data) {
        /* Failure Case: Empty JSON || Issue to manage */
        if(!data || Object.keys(data).length === 0){
          log('checkAvailability() did not find any product');
        }
        /* Success Case */
        else{
          var i = 0;
          $.each(data, function(key, value) {
            setupAddToBag(value, i);
            i = i + 1;
          });
        }
      },
      error: function(jqXHR, exception) {
        errorHandler(jqXHR.status, exception, "ProductStylesJSONView");
        log('checkAvailability() call to ProductStylesJSONView failed');
      }
    });
  };

  var setupAddToBag = function(data, index) {
    var $addToBagButton = $('.standalone-shoppable[data-catEntryId="' + data.catentryId + '"]');

    /* UPC product */
    var sku = data.imageUrl.replace('//images.ray-ban.com/is/image/RayBan/', '');
    var upc = sku.match(/[0-9]{4}[^_]*/g);

    /* Availability */
    var ava;
    /* Delivery date */
    var ddate;

    /* Populate productsDetails array by UPC */
    if (data.partNumber == upc) {
      ava = data.addToBagFlag;
      ddate = data.availabilityMessage;
    }

    // data-element-id for analytics tracking: "<device>_<pageName&Type>_<pageArea>_<Element>"
    var elementId = deviceType() + '_' + $addToBagButton.data('tea-pagename') + '_' + $addToBagButton.data('tea-pagearea') + '_' + $addToBagButton.data('tea-element') + index;
    var modalIndex = index + 1;
    if (ddate != undefined) {
      ddate = ddate.replace('&gt;', '>');
      ddate = ddate.replace('&lt;', '<');
      ddate = ddate.replace('&lt;/span&gt;', '</span>')
    } else {
      ddate = '';
    }

    /* Populate "add to bag" button with missing information */
    $addToBagButton
      //.attr('data-url', data.linkDetailsView) // store segment must be prepended to linkDetailsView
      .attr('data-description', upc)
      .attr('data-element-id', elementId)
      .attr('data-price', data.offerPrice)
      .attr('data-modalIndex', modalIndex)
      .attr('data-ddate', ddate);

    if (ava == 'Y') {

      /* AVAILABLE CASE */

      /* Analytics data to push on mouse down event */
      var tealium_products = {};
      tealium_products['' + upc] = {
        Units: 1,
        Price: data.offerPrice.replace(/[^0-9.,]/g, ""),
        Status: 'Available',
        DataSource: data
      };
      var tealium_data = {
        'id': 'X-X-X-X-AddToCart',
        'Products': tealium_products
      };

      // Enable button, implement track analytics and addToBag on click
      $addToBagButton
        .mousedown(function () {
          tealium_data2track.push(tealium_data);
        })
        .click(function(e) {
          e.stopPropagation();
          e.preventDefault();
          addToBag($(this).attr('data-catEntryId'));
        })
        .removeAttr('disabled')
        .attr('aria-disabled', "false");

    } else {

      /* NOT AVAILABLE CASE */
      $addToBagButton.addClass('wcs-hide');
    }
  };

  /* Execute the add to bag for the given catEntryId.
   * In page there must be a button having class "standalone-shoppable" and data-catEntryId equal to the one passed as parameter.
   * Moreover the method init() must have been called already to check the availability.
   *
   * @params: catEntry Id for prod
   * @returns: true if add to bag is completed successfully */
  var addToBag = function(catEntryId) {
      var $addToBagButton = $('.standalone-shoppable[data-catEntryId="' + catEntryId + '"]');

      if (window.Rayban && Rayban.PrivateSaleInstance && !Rayban.PrivateSaleInstance.userTryToAddProduct(null, catEntryId)) {
          return false;
      }

      /* Vars for mobile overlay */

      /* Mobile solution */
      if (deviceType() === 'M') {
        initMobileOverlayAddToBag();
      }

      var urlToCall = host.indexOf('localhost') >= 0 ? '/webapp/wcs/stores/servlet' : '';
      urlToCall = urlToCall + "/AjaxOrderItemAdd?" +
        "URL=ShopCartDisplayView" +
        "&field1=0" +
        "&orderId=" + config.orderId +
        "&orderAgain=" +
        "&storeId=" + config.storeId +
        "&calculateOrder=1" +
        "&calculationUsage=-1%2C-3%2C-2%2C-4" +
        "&langId=" + config.langId +
        "&pageName=ProductPage" +
        "&xdkInterestItem_Id=" +
        "&configurationId=&" +
        "pgName=PDP&" +
        "catEntryId=" + catEntryId +
        "&quantity=1";
      $.ajax({
        method: "GET",
        dataType: "json",
        url: urlToCall,
        beforeSend: function(){
          if (deviceType() === 'M') {
            // Mobile solution
            showMobileOverlayAddToBag();
          } else {
            // Desktop solution
            $addToBagButton.addClass('adding');
          }
        },
        success: function (data) {
          /* Case: Sold Out!*/
          if (data.errorCode != null) {
            if (deviceType() === 'M') {
              // Mobile solution
              $('.rb-pdp-action-overlay').fadeOut(function() {
                log(errorMsg);
                $('.rb-pdp-action-overlay-bag,#pdp-acc-popup').remove();
              });
            } else {
              /* Desktop solution */
              log("SOLDOUT!");
            }
          }
          /* Case: no Sold Out!*/
          else {
            if (deviceType() === 'M') {
              // Mobile solution
              $('.accPopup-continue, .accPopup-procd-checkout').show();
              sn.pubsub.publish("basket_updated");
              $('html,body').animate({scrollTop: 0},'slow');
            } else {
              // Desktop solution
              window.add_product_tobag(data);
              setTimeout(function(){
                $addToBagButton.removeClass('adding');
              }, 3000);
            }

          }
        },
        error: function(jqXHR, exception) {
          log('addToBag() call to AjaxOrderItemAdd failed');
          errorHandler(jqXHR.status, exception, "AjaxOrderItemAdd");
        }
      });
  };

  var initMobileOverlayAddToBag = function () {
    var M_PDP_WhatsNext_ProceedCheckout = $('#M_PDP_WhatsNext_ProceedCheckout').text();
    var M_PDP_WhatsNext_ContinueShopping = $('#M_PDP_WhatsNext_ContinueShopping').text();
    $('.rb-pdp-action-overlay-bag,#pdp-acc-popup').remove();
    $('.rb-main').prepend('<div class="rb-pdp-action-overlay rb-pdp-action-overlay-bag" style="background-position: 50% 60px;"></div><div id="pdp-acc-popup" class="pdp-acc-popup" style="display: none;"> <span class="acc-up-arrow" style="display: none;"></span> <span class="wcs-close-btn" style="display: none;"></span> <div class="accs-add-popup-innerWrapper" style="display: none;"></div><div class="accPopup-continue" id="M_PDP_WhatsNext_ContinueShopping">'+M_PDP_WhatsNext_ContinueShopping+'</div><a class="accPopup-procd-checkout" id="M_PDP_WhatsNext_ProceedCheckout" href="/ShopCartDisplayView?catalogId='+ config.catalogId +'&langId='+ config.langId +'&pageId=cart&storeId='+ config.storeId +'">'+M_PDP_WhatsNext_ProceedCheckout+'</a></div>');
    $('.accPopup-continue').click(function() {
      $("#pdp-acc-popup,.rb-pdp-action-overlay-bag").hide();
    });
  };

  var showMobileOverlayAddToBag = function () {
    $("#pdp-acc-popup,.rb-pdp-action-overlay-bag").show();
  };

  var log = function(message) {
    console.log(message)
  };

  /* Handler to manage errors */
  var errorHandler = function(status, exception, service) {
    var msg = '';
    if (status === 0) {
      msg = 'Not connect.\n Verify Network.';
    } else if (status == 404) {
      msg = 'Requested page not found. [404]';
    } else if (status == 500) {
      msg = 'Internal Server Error [500].';
    } else if (exception === 'parsererror') {
      msg = 'Requested JSON parse failed.';
    } else if (exception === 'timeout') {
      msg = 'Time out error.';
    } else if (exception === 'abort') {
      msg = 'Ajax request aborted.';
    } else {
      msg = 'Uncaught Error.\n' + jqXHR.responseText;
    }
    errorMsg = msg;
    log("Attention: error occurs in " + service + " [ws call request]!");
    log("-> Details <-");
    log(msg);
  };

  /* Detect what is the user device type:
   *  D: DESKTOP (window width >= 768px)
   *  M: MOBILE (window width < 768px)
   */
  var deviceType = function(){
    return $(window).width() >= 768 ? "D": "M";
  };

  /* Autoinit this module */
  init();

})();

